class HttpService {
	constructor() {
		this.baseUrl = 'http://localhost:4200';
		// this.baseUrl = 'https://osijek-craft-beer.net';
	}

	async getBookingsAsync(token) {
		const options = {
			method: 'POST',
			body: JSON.stringify({ token }),
			headers: {
				'Content-Type': 'application/json',
			},
		}
		return fetch(`${this.baseUrl}/booking`, options);
	}

	async getBookingByIdAsync(id) {
		const url = `${this.baseUrl}/booking?bookingId=${id}`;
		const response = await fetch(url);

		return await response.json();
	}

	async getProductCategoriesAsync() {
		const url = `${this.baseUrl}/product-category`;
		const response = await fetch(url);

		return await response.json();
	}

	async getBookingProductsAsync(bookingId) {
		const url = `${this.baseUrl}/booking-product/${bookingId}`;
		const response = await fetch(url);

		return await response.json();
	}

	async postBookingProductAsync(data) {
		try {
			const url = `${this.baseUrl}/booking-product`;
			const requestOpts = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data),
			};

			const response = await fetch(url, requestOpts);

			return await response.json();
		} catch (err) {
			debugger;
		}
	}

	async putBookingAsync(id, booking) {
		try {
			const url = `${this.baseUrl}/booking/${id}`;
			const requestOpts = {
				method: 'PUT',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(booking),
			};

			const response = await fetch(url, requestOpts);

			return await response.json();
		} catch (err) {
			debugger;
		}
	}

	async deleteBookingProductAsync(id) {
		try {
			const url = `${this.baseUrl}/booking-product/${id}`;
			const requestOpts = {
				method: 'DELETE',
			};

			const response = await fetch(url, requestOpts);

			return await response.json();
		} catch (err) {
			debugger;
		}
	}

	authAsync(resource) {
		const options = {
			method: 'POST',
			body: JSON.stringify(resource),
			headers: {
				'Content-Type': 'application/json'
			}
		}
		return fetch(`${this.baseUrl}/auth`, options);
	}
}

export default HttpService;
